"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secToTimeArr = exports.timeStamp = void 0;
var admin_1 = require("services/page/admin");
var time_1 = require("utils/time");
exports.timeStamp = function (timeSpan) {
    return Math.ceil(new Date().getTime() / 1000) + Number(timeSpan);
};
exports.secToTimeArr = function (leftTime, state) {
    var result = {
        day: "",
        hour: "",
        min: "",
        sec: ""
    };
    if (leftTime > -1) {
        var onlyOnGoing = state === admin_1.TActState.OnGoing ? time_1.EnFormateDays(leftTime) * time_1.SECONDS_IN_A_DAY : 0;
        var newTime = leftTime - onlyOnGoing;
        var hour = Math.floor(newTime / 3600).toString();
        var min = (Math.floor(newTime / 60) % 60).toString();
        var s = (newTime % 60).toString();
        if (state === admin_1.TActState.OnGoing) {
            var days = time_1.EnFormateDays(leftTime);
            result.day = String(days);
        }
        if (Number(hour) < 10) {
            hour = "0" + hour;
        }
        result.hour = hour;
        if (Number(min) < 10) {
            min = "0" + min;
        }
        result.min = min;
        if (Number(s) < 10) {
            s = "0" + s;
        }
        result.sec = s;
    }
    return result;
};
